import { render, staticRenderFns } from "./VideoCardsGrid.vue?vue&type=template&id=72d152b6&scoped=true"
import script from "./VideoCardsGrid.vue?vue&type=script&lang=js"
export * from "./VideoCardsGrid.vue?vue&type=script&lang=js"
import style0 from "./VideoCardsGrid.vue?vue&type=style&index=0&id=72d152b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d152b6",
  null
  
)

export default component.exports